import { render, staticRenderFns } from "./CbsVerticalNavMenu.vue?vue&type=template&id=d6ddf854"
import script from "./CbsVerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./CbsVerticalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./CbsVerticalNavMenu.vue?vue&type=style&index=0&id=d6ddf854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports